export const hiddenInsuranceReportPrintStyles = `
  @page { size: A4 portrait; margin: 10mm; }
  * { box-sizing: border-box; }
  body {
    margin: 0;
    font-family: "Malgun Gothic", "Apple SD Gothic Neo", sans-serif;
    color: #0f172a;
    background: #fff;
    font-size: 11px;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  .hidden-insurance-report-doc { max-width: none; padding: 0; }
  header { border-bottom: 2px solid #1e3a5f; padding-bottom: 8px; margin-bottom: 8px; }
  h1 { margin: 2px 0 0; font-size: 17px; }
  h2 { margin: 0; font-size: 12px; }
  section { margin-top: 8px; page-break-inside: avoid; }
  ul { margin: 0; padding-left: 16px; }
  li { font-size: 11px; line-height: 1.5; }
  p { margin: 0; }
  .rounded-xl, .rounded-lg, .rounded { border-radius: 8px; }
  .border { border: 1px solid #e2e8f0; }
  .border-brand-navy { border-color: #1e3a5f; }
  .border-amber-100 { border-color: #fde68a; }
  .border-slate-100 { border-color: #f1f5f9; }
  .border-slate-200 { border-color: #e2e8f0; }
  .bg-white { background: #fff; }
  .bg-slate-50 { background: #f8fafc; }
  .bg-amber-50 { background: #fffbeb; }
  .text-brand-navy { color: #1e3a5f; }
  .text-slate-900 { color: #0f172a; }
  .text-slate-800 { color: #1e293b; }
  .text-slate-700 { color: #334155; }
  .text-slate-600 { color: #475569; }
  .text-slate-500 { color: #64748b; }
  .text-amber-950 { color: #451a03; }
  .text-amber-900 { color: #78350f; }
  .text-xs { font-size: 11px; }
  .text-\\[10px\\] { font-size: 10px; }
  .text-\\[11px\\] { font-size: 11px; }
  .text-sm { font-size: 12px; }
  .text-base { font-size: 14px; }
  .text-xl { font-size: 18px; }
  .text-2xl { font-size: 20px; }
  .leading-tight { line-height: 1.2; }
  .gap-x-3 { column-gap: 10px; }
  .gap-x-4 { column-gap: 14px; }
  .min-w-\\[220px\\] { min-width: 220px; }
  .max-h-\\[88px\\] { max-height: 88px; }
  .sm\\:grid-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }
  .text-amber-700 { color: #b45309; }
  .font-medium { font-weight: 500; }
  .font-semibold { font-weight: 600; }
  .font-bold { font-weight: 700; }
  .font-extrabold { font-weight: 800; }
  .grid { display: grid; }
  .grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
  .grid-cols-5 { grid-template-columns: repeat(5, minmax(0, 1fr)); }
  .gap-2 { gap: 8px; }
  .gap-3 { gap: 12px; }
  .mt-0\\.5 { margin-top: 2px; }
  .mt-1 { margin-top: 3px; }
  .mt-1\\.5 { margin-top: 4px; }
  .mt-2 { margin-top: 6px; }
  .mt-3 { margin-top: 8px; }
  .mt-4 { margin-top: 10px; }
  .mt-5 { margin-top: 12px; }
  .gap-1 { gap: 4px; }
  .gap-1\\.5 { gap: 4px; }
  .px-2 { padding-left: 8px; padding-right: 8px; }
  .px-3 { padding-left: 10px; padding-right: 10px; }
  .px-4 { padding-left: 12px; padding-right: 12px; }
  .py-1\\.5 { padding-top: 4px; padding-bottom: 4px; }
  .py-2 { padding-top: 6px; padding-bottom: 6px; }
  .py-2\\.5 { padding-top: 8px; padding-bottom: 8px; }
  .py-3 { padding-top: 10px; padding-bottom: 10px; }
  .p-3 { padding: 10px; }
  .p-4 { padding: 12px; }
  .pb-3 { padding-bottom: 10px; }
  .pb-4 { padding-bottom: 12px; }
  .pt-2 { padding-top: 6px; }
  .pt-3 { padding-top: 8px; }
  .text-lg { font-size: 16px; }
  .text-\\[9px\\] { font-size: 9px; }
  .leading-snug { line-height: 1.35; }
  .space-y-0\\.5 > * + * { margin-top: 2px; }
  .grid-cols-12 { grid-template-columns: repeat(12, minmax(0, 1fr)); }
  .col-span-1 { grid-column: span 1 / span 1; }
  .col-span-2 { grid-column: span 2 / span 2; }
  .col-span-3 { grid-column: span 3 / span 3; }
  .col-span-4 { grid-column: span 4 / span 4; }
  .col-span-5 { grid-column: span 5 / span 5; }
  .flex-row { flex-direction: row; }
  .items-stretch { align-items: stretch; }
  .h-full { height: 100%; }
  .flex-col { flex-direction: column; }
  .flex-1 { flex: 1 1 0%; }
  .justify-center { justify-content: center; }
  .min-w-\\[100px\\] { min-width: 100px; }
  .w-\\[72px\\] { width: 72px; }
  .gap-1\\.5 { gap: 4px; }
  .pl-1\\.5 { padding-left: 6px; }
  .px-1 { padding-left: 4px; padding-right: 4px; }
  .py-1 { padding-top: 4px; padding-bottom: 4px; }
  .py-1\\.5 { padding-top: 6px; padding-bottom: 6px; }
  .text-\\[7px\\] { font-size: 7px; }
  .text-\\[8px\\] { font-size: 8px; }
  .leading-tight { line-height: 1.2; }
  .whitespace-nowrap { white-space: nowrap; }
  .pr-2 { padding-right: 8px; }
  .border-l { border-left: 1px solid #f1f5f9; }
  .pl-2 { padding-left: 8px; }
  .space-y-0\\.5 > * + * { margin-top: 2px; }
  .pt-0\\.5 { padding-top: 2px; }
  .text-center { text-align: center; }
  .md\\:col-span-4 { grid-column: span 4 / span 4; }
  .md\\:col-span-8 { grid-column: span 8 / span 8; }
  .md\\:items-start { align-items: start; }
  .sm\\:grid-cols-5 { grid-template-columns: repeat(5, minmax(0, 1fr)); }
  .flex { display: flex; }
  .items-center { align-items: center; }
  .items-start { align-items: flex-start; }
  .items-baseline { align-items: baseline; }
  .justify-between { justify-content: space-between; }
  .flex-wrap { flex-wrap: wrap; }
  .min-w-0 { min-width: 0; }
  .shrink-0 { flex-shrink: 0; }
  .truncate { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .space-y-1 > * + * { margin-top: 4px; }
  .space-y-1\\.5 > * + * { margin-top: 6px; }
  .space-y-2 > * + * { margin-top: 8px; }
  .leading-relaxed { line-height: 1.6; }
  .uppercase { text-transform: uppercase; }
  .tracking-wide { letter-spacing: 0.04em; }
  .border-b-2 { border-bottom-width: 2px; }
  .border-t { border-top-width: 1px; border-top-style: solid; }
  .hi-report-chart svg { display: block; width: 100%; height: auto; }
  .hi-report-chart .inline-flex { display: inline-flex; align-items: center; }
  .hi-report-chart .gap-1\\.5 { gap: 6px; }
  .hi-report-chart .gap-x-4 { column-gap: 16px; }
  .hi-report-chart .gap-y-1 { row-gap: 4px; }
  .hi-report-chart .h-2\\.5 { height: 10px; }
  .hi-report-chart .w-2\\.5 { width: 10px; }
  .hi-report-chart .rounded-sm { border-radius: 2px; }
  .inline-block { display: inline-block; }
  .hi-report-possibility-grid {
    display: grid;
    grid-template-columns: 58px minmax(0, 1fr) minmax(84px, 92px) minmax(60px, 68px) minmax(96px, 108px);
    gap: 6px;
    align-items: stretch;
  }
  .hi-report-possibility-grid > * { min-height: 100%; height: auto; }
  .hi-report-claim-summary-grid {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(84px, 104px) minmax(64px, 80px) minmax(96px, 112px);
    gap: 6px;
    align-items: stretch;
  }
  .hi-report-claim-summary-grid > * { min-height: 100%; height: auto; }
  .hi-report-breakdown-line {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    column-gap: 8px;
    align-items: start;
  }
  .min-h-full { min-height: 100%; }
  .w-full { width: 100%; }
  .break-keep { word-break: keep-all; overflow-wrap: break-word; }
  .tabular-nums { font-variant-numeric: tabular-nums; }
  .text-right { text-align: right; }
  .leading-none { line-height: 1; }
  .mt-2 { margin-top: 6px; }
  .pt-1\\.5 { padding-top: 4px; }
  .space-y-1 > * + * { margin-top: 4px; }
  br { display: block; content: ""; margin-top: 1px; }
`
